import { get } from 'lodash';

/** are we showing 'New Barber' step by step form or 'Edit Barber' save any tab form */
export const isEditMode = props => !!get(props, 'params.barberId');

/** is the barber already saved in db. in 'New Barber' form we save barber to db after step 2 (Locations) */
export const isEditingExistingBarber = props => !!get(props, 'brandBarberId');
